import Box from '@mui/material/Box'
import { DynamicCreditCardIcons } from '@/core/components/CreditCard/dynamic-creditcard-icons.component'
import { detectCardBrand, formatCardNumber } from '@/core/utils'
import { UInput } from '../../UInput.component'
import { getFieldTestId } from '../field-helpers'
import type { FieldRenderer } from '../types'

const renderCardNumberField: FieldRenderer = ({ field, ctx, t }) => {
    const key = field.key
    const raw = (ctx.form[key] as string) ?? ''
    const brand = detectCardBrand(raw)

    return (
        <UInput
            key={key}
            label={t(field.label)}
            value={formatCardNumber(raw)}
            onChange={e => {
                const next = e.target.value.replace(/\D/g, '')
                ctx.setForm((prev: Record<string, unknown>) => ({ ...prev, [key]: next }))
            }}
            fullWidth
            disabled={ctx.formDisabled}
            InputProps={{
                endAdornment: brand ? (
                    <Box sx={{ pr: 1, display: 'flex', alignItems: 'center' }} data-testid={getFieldTestId(ctx, key, 'brand-icon-box')}>
                        <DynamicCreditCardIcons paymentOptions={brand} height={20} data-testid={getFieldTestId(ctx, key, 'brand-icon')} />
                    </Box>
                ) : undefined
            }}
            slotProps={{
                htmlInput: {
                    inputMode: 'numeric',
                    maxLength: 19,
                    'data-testid': getFieldTestId(ctx, key, 'input')
                }
            }}
            data-testid={getFieldTestId(ctx, key, 'uinput')}
        />
    )
}

export default renderCardNumberField
